<template>
  <div>
    <!-- init step -->
    <v-card-actions class="justify-space-between">
      <v-spacer></v-spacer>
      <v-item-group v-model="onboarding" class="text-xs-center" mandatory>
        <v-item v-for="n in passos" :key="`btn-${n}`">
          <v-btn
            class="step-analise-credito"
            slot-scope="{ active, toggle }"
            :input-value="active"
            icon
            @click="toggle"
          >
            <i class="material-icons">{{
              active ? "brightness_1" : "panorama_fish_eye"
            }}</i>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-spacer></v-spacer>
    </v-card-actions>
    <!-- end step -->

    <v-card>
      <!-- init passo 1 -->
      <v-card-text v-if="onboarding == 0">
        <v-container grid-list-xl class="form-analise-credito">
          <v-flex xs12>
            <p class="titulo">Upload de Documentos</p>
          </v-flex>
          <anexo-list-component
            :documentosSolicitados.sync="pendenciasCopia"
            :classColuna="'lg4 md6 sm12'"
            :mostraDescricao="true"
            :mostraTitulo="true"
            @send="setUpdateDocumentos"
            @setDocumentosModel="this.solicitarAnalise"
          ></anexo-list-component>
        </v-container>
      </v-card-text>
      <!-- end passo 3 -->
    </v-card>

    <v-layout row wrap pt-4>
      <v-flex text-xs-left>
        <v-btn
          class="button jns-button blue-button flex"
          v-show="onboarding > 0"
          @click="prev()"
          >Voltar</v-btn
        >
      </v-flex>
      <v-flex text-xs-right>
        <v-btn
          class="button jns-button yellow-button no-margin-top"
          @click="avancar()"
          >{{
            passos > onboarding + 1 ? "Próximo Passo" : "Solicitar Análise"
          }}</v-btn
        >
      </v-flex>
    </v-layout>

    <v-dialog v-model="documentosSucessoModal" :max-width="'640'">
      <base-modal>
        <h3>Proposta enviada para análise com sucesso!</h3>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8 pb-0>
            <v-btn
              class="button jns-button yellow-button mt-4"
              @click="$router.go()"
              >OK</v-btn
            >
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </div>
</template>

<script lang="js">
import { eventBus } from "../main";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "ProcessoAnaliseSubscricao",
  mixins: [ViewMixin],
  data() {
    return {
      pendenciasCopia: [],
      passos: 1,
      onboarding: 0,
      documentosSucessoModal: false,
    };
  },
  props: {
    pendencias: { type: Array },
    isEndorsement: { type: Boolean, default: false }
  },
  methods: {
    async solicitarAnalise(modelDocumentos) {
      if (modelDocumentos.length === 0) return;
      var model = {
        documentos: modelDocumentos,
      };
      try {
        this.showLoadingAskWait();
        await this.$store.dispatch(this.getAction(), this.getPayload(model));

        this.documentosSucessoModal = true;
      } catch (e) {
        this.setErrorModal(e.response.data);
        return;
      } finally {
        this.hideLoadingAskWait();
      }
    },

    getPayload(model) {
      return (
        this.isEndorsement
          ? { apoliceId: this.$route.params.apoliceId, model }
          : {
            propostaId: this.$route.params.propostaId,
            produtoId: this.$route.params.produtoId,
            model
          }
      );
    },

    getAction() {
      return this.isEndorsement ? "SEND_ENDORSEMENT_DOCUMENTS" : "POST_REVISAO_SUBSCRICAO";
    },

    getEndorsementPendencies(pendencies) {
      const requiredPendencies = [];
      if (!pendencies.some(pendencia => pendencia.id === 666)) {
        requiredPendencies.push({
          nome: "Termos Aditivos Apostilamentos Oficios",
          descricao: "Termos Aditivos Apostilamentos Oficios",
          id: 666,
          obrigatorio: true
        });
      }
      const contratoPendency = pendencies.find(pendencia => pendencia.nome === "Contrato");
      if (contratoPendency) {
        contratoPendency.id = 999;
      } else {
        requiredPendencies.push({
          nome: "Contrato",
          descricao: "Contrato",
          id: 999,
          obrigatorio: true
        });
      }
      return [{ categoria: "Subscrição", listagem: [...requiredPendencies, ...pendencies] }];
    },

    avancar() {
      var isValid = true;

      switch (this.onboarding) {
        case 0:
          if (this.validaAnexos()) eventBus.$emit("setModelAnexos");
          else this.$forceUpdate();

          break;
      }
    },

    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },

    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },

    setUpdateDocumentos(data) {
      this.pendenciasCopia = data;
      this.$forceUpdate();
    },

    validaAnexos() {
      var isValid = true;

      this.pendenciasCopia.forEach((categoria) => {
        if (categoria.listagem && categoria.listagem.length) {
          for (var i = 0; i < categoria.listagem.length; i++) {
            if (
              (!categoria.listagem[i].arquivos ||
                !categoria.listagem[i].arquivos.length) &&
              categoria.listagem[i].obrigatorio
            )
              isValid = false;
          }
        }
      });
      if (!isValid) eventBus.$emit("validaAnexos");

      return isValid;
    },
  },
  created() {
    this.pendenciasCopia = this.pendencias
      ? this.isEndorsement
        ? this.getEndorsementPendencies(this.pendencias)
        : JSON.parse(JSON.stringify(this.pendencias))
      : [];
    this.$forceUpdate();
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 959px) {
  .container {
    padding: 0.5vh 1vh !important;
  }
}

@media only screen and (min-width: 960px) {
  .container {
    max-width: 100% !important;
  }
}

.v-card__title {
  padding: 7vh 0 2vh 0;
  justify-content: center;

  .headline {
    font-weight: 900;
    font-size: 3vh !important;
    color: #061d45;
  }
}

.v-card__actions {
  .v-btn--active:before {
    background-color: transparent;
  }

  i {
    font-size: 1.5vh;
    color: #282498;
  }
}

.v-card__text {
  overflow: auto;
}

.blue-button {
  margin: 6px 8px !important;
}

.v-btn {
  text-transform: none;
}

.button {
  max-width: 25vh;
}

.container,
.v-card__actions {
  padding: 1vh 5vh;
}

.container {
  padding: 0.5vh 5vh !important;
}

.step-analise-credito {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// ./src/components/ProcessoAnaliseSubscricao.vue